










































































































































































































import Component from 'vue-class-component'
import { Vue, Prop } from 'vue-property-decorator'
import { ChartData, ChartOptions } from 'chart.js'
import Chart from '@/components/Chart.vue'
import ProductSuggest from '@/components/ProductSuggest.vue'

@Component({
  components: {
    Chart,
    ProductSuggest
  }
})
export default class Result extends Vue {
  @Prop()
  values?: number[]

  @Prop()
  conditionType?: any

  @Prop()
  shampooDataArray?: any

  @Prop()
  typeIntroduction?: string

  get localValues () {
    if (this.values !== undefined) {
      return this.values.map((point: number) => point * 0.75)
    } else {
      return [5, 5, 5, 5, 5]
    }
  }

  private chartData: ChartData = {
    labels: ['泡立ち', '頭皮への優しさ', '髪の補修力', '安全性', '　　仕上がり'],
    datasets: [
      {
        label: '頭皮・髪の健康状態',
        data: this.localValues,
        backgroundColor: [
          'rgba(255, 190, 11, 0.8)'
        ],
        borderColor: [
          'rgba(255, 190, 11, 1)'
        ],
        borderWidth: 1
      }
    ]
  }

  private chartOption: ChartOptions = {
    scale: {
      angleLines: {
        display: false
      },
      ticks: {
        suggestedMin: 0,
        suggestedMax: 6
      }
    },
    legend: {
      display: false
    },
    title: {
      display: true,
      text: 'アナタに合うシャンプータイプ',
      fontSize: 18,
      fontColor: '#000000'
    }
  }

  public openWindow (url: string) {
    if (url === 'https://www.youtube.com/channel/UCcBv10OsykgKm2IZnhxx__g') {
      this.$ga.event('toYouTube', 'push')
    }
    if (url === 'https://www.instagram.com/select_shampoo/') {
      this.$ga.event('toInstagram', 'push')
    }
    if (url === 'https://cramel.jp/productlist/14') {
      this.$ga.event('toCramel', 'push')
    }
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public pushBannerTop (url: string) {
    this.$ga.event('pushBannerTop', 'push')
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public pushBannerMiddle (url: string) {
    this.$ga.event('pushBannerMiddle', 'push')
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public toCramelBottomBanner (url: string) {
    this.$ga.event('toCramelBottomBanner', 'push')
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  public pushBannerBota () {
    this.$ga.event('banner_BOTA', 'push')
    window.open('https://monicam.jp/campaign/405', '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }
}
